export const fetchPlacementInfo = dcmCampaignId => {
  if (dcmCampaignId) {
    return fetch(
      process.env.REACT_APP_API_URL +
        `/api/sql/placementInfo?campaignId=${dcmCampaignId}`
    )
      .then(
        response => response.json(),
        error => console.log("An error occurred.", error)
      )
      .then(json => {
        return json;
      });
  } else {
    return [];
  }
};
